type PageInfo = {
    __typename: 'PageInfo';
    startCursor: string | null | undefined;
    endCursor: string | null | undefined;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
};

type ConnectionObject<Edge> = {
    edges: Edge[];
    pageInfo: PageInfo;
    totalCount: number;
};

export function translateConnectionObjectToArray(connectionObj: ConnectionObject<any>): any[] {
    return connectionObj.edges.map((edge) => {
        return edge.node;
    });
}
